export default "/_next/static/images/ai-refine-card-1fce47b9dd2faafc414fd9a050bd2145.png";